import PropTypes from 'prop-types'
import { ErrorMessage } from 'formik'
import { useTranslation } from 'react-i18next'

const FormInput = ({ className, label, name, isOptional, children }) => {
  const { t } = useTranslation(['eventManagement'])

  return (
    <div className={`event-form-input ${className || ''}`}>
      <p className="event-form-input__label">
        <span>{label}</span>
        {isOptional ? ` (${t('eventManagement:common.optional')})` : ''}
      </p>
      {children}
      <ErrorMessage name={name} component="div" className="event-form-input__error" />
    </div>
  )
}

FormInput.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isOptional: PropTypes.bool,
  children: PropTypes.element.isRequired,
}

export default FormInput
